import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { CONSULTATIONS } from "../data/consultations";

const Consultations = () => {
  return (
    <div data-testid="consultations-page" className="pt-32 md:pt-40 pb-24">
      <div className="px-6 md:px-12 lg:px-20">
        <div className="flex items-center gap-4 mb-10">
          <span className="h-px w-12 bg-[#0a0a0b]/30" />
          <span className="text-[10px] tracking-[0.4em] uppercase text-muted-ink">All Services</span>
        </div>
        <h1
          data-testid="consultations-headline"
          className="font-display font-medium tracking-tight leading-[0.95] text-[#0a0a0b] max-w-5xl"
          style={{ fontSize: "clamp(2.6rem, 6.5vw, 6rem)" }}
        >
          Five disciplines, <span className="accent-text">one studio.</span>
        </h1>
        <p className="mt-8 max-w-2xl text-base md:text-lg text-muted-ink">
          A complete digital marketing, technology, and business consultancy
          practice. Strategy, build, and intelligence under one roof.
        </p>
      </div>

      <div className="mt-16 md:mt-20 px-6 md:px-12 lg:px-20 grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
        {CONSULTATIONS.map((c, i) => (
          <motion.div
            key={c.slug}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, delay: (i % 6) * 0.08, ease: [0.22, 1, 0.36, 1] }}
            className="group"
          >
            <Link
              to={`/services/${c.slug}`}
              data-testid={`consultation-card-${c.slug}`}
              className="block relative isolate overflow-hidden bg-surface hairline rounded-[2px] p-7 md:p-8 h-full"
            >
              <div
                aria-hidden
                className="pointer-events-none absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                style={{
                  background:
                    "radial-gradient(60% 50% at 0% 0%, rgba(110,91,255,0.10), transparent 70%)",
                }}
              />
              <div className="relative">
                <span className="text-[10px] tracking-[0.4em] uppercase text-muted-ink">
                  {c.n} · {c.category}
                </span>
              </div>
              <h3
                className="relative mt-6 font-display font-medium tracking-tight leading-[1.05] text-[#0a0a0b] transition-transform duration-500 group-hover:-translate-y-1"
                style={{ fontSize: "clamp(1.6rem, 2.4vw, 2.2rem)" }}
              >
                {c.title}
              </h3>
              <p className="relative mt-3 accent-text font-medium">{c.tagline}</p>
              <p className="relative mt-3 text-sm text-muted-ink line-clamp-3">{c.body}</p>
              <div className="relative mt-6 inline-flex items-center gap-2 text-xs tracking-[0.3em] uppercase text-[#0a0a0b]">
                Explore <ArrowUpRight size={14} />
              </div>
              <div
                className="absolute bottom-0 left-0 h-px w-0 group-hover:w-full transition-[width] duration-700 accent-gradient"
                aria-hidden
              />
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Consultations;
